import React from 'react';
import { array, func, number, bool } from 'prop-types';
const DynamicProperty = ( {list, loadLess, loadMore, endLimit, isLoadLess, isLoadMore, pagination} ) => {
  //Remove this code, this will be temo untill backend code refactor
  // document.querySelector('.onload-page-container').classList.add('hide');
  if(pagination === 1) {
    isLoadLess = true;
    isLoadMore = true;
  }

  if(list.length === 0) {
    return (
      <div>There is no property matching with the search key</div>
    )
  }
  
  function computeLocationText(hotel) {
    let locationText='';
    if(hotel.city || hotel.city.length > 1) {
      locationText+= `${hotel.city},`
    }
    if(hotel.state_name || hotel.state_name.length > 1) {
      locationText+= ` ${hotel.state_name},`
    }
    if(hotel.country_name || hotel.country_name.length > 1) {
      locationText+= ` ${hotel.country_name}`
    }
    return locationText;
  }
  return(
      <div className="find-a-hotel-suggestions">
        {list.slice(0, endLimit).map((hotel, index) => {    
          return (
            <div key={ index } itemProp="makesOffer" itemScope="" itemtype="http://schema.org/Offer"
            className="property-push clearfix package-wrapper rss-item package property-filter NC the-dunhill-hotel  active first-group"
            rel="the-dunhill-hotel">
            <div className="package-image inset">
                <img itemProp="image"  src={hotel.package_image}
                    alt={hotel.property_name}/>
            </div>
            <div className="property-push-content">
                <div className="package-property-wrap">
                    <div className="package-property-name">{ hotel.property_name }</div>
                    <div className="package-location">
                    {computeLocationText(hotel)}</div>
                </div>
                <h4 className="package-title" itemProp="name">{ hotel.package_title}</h4>
                <div className="package-content">
        
                    <div className="package-short" itemProp="description">
                        <p>
                            { hotel.short_desc }
                        </p>
                    </div>
                    <div className="package-long">
                            { hotel.long_desc }
                    </div>
                </div>
            </div>
            <p className="cta">
                <a itemProp="url" className="learn-more button"  href={`http://${window.location.hostname}/us/${ hotel.learn_more }`}
                    id="pk-574f09d6836dcb0d1ea6c270">Learn
                    More</a>
                <a title="Book now at The Dunhill Hotel" className="reserve track link book-now button" 
                    name="reservations::packages:the-dunhill-hotel:romantic-getaway-dunhill"
                    href={ hotel.book_now }>Book
                    Now</a>
            </p>
            </div>
          );
        })}
        <div className="filter-button-container">
        <button
          disabled={isLoadLess}
          className="button filter load-less"
          onClick={() => loadLess()}
          >Load Less
          </button>
          <button
          onClick={() => loadMore()}
          disabled={isLoadMore}
            className="button filter load-more"
            >Load More
          </button>
         
          </div>
      </div>
  )
}

DynamicProperty.propTypes = {
    list: array,
    loadLess: func.isRequired,
    loadMore: func.isRequired,
    endLimit: number.isRequired,
    isLoadLess: bool.isRequired,
    isLoadMore: bool.isRequired,
    pagination: number.isRequired,
    
  };

export default DynamicProperty;